import { get, put, post, fetchget2 } from "../request.js";

export const ApiDailySpeechGetQuiz = {
  get: (stuId) => {
    if (!stuId) {
      throw new Error("Student ID is required to fetch daily speech quiz.");
    }
    return get(`/daily-speech/get_quiz/${stuId}`);
  },
};

export const ApiDailySpeechAnswer = {
  put: (contentId, score) => {
    if (!contentId) {
      throw new Error(
        "Daily speech content ID is required when submitting an answer."
      );
    }

    const normalizedScore =
      score === null || score === undefined ? "null" : score;

    return put(`/daily-speech/answer/${contentId}/${normalizedScore}`);
  },
};

export const ApiDailySpeechGetList = {
  get: (stuId, status) => {
    if (!stuId) {
      throw new Error("Student ID is required to fetch daily speech list.");
    }

    if (!status) {
      throw new Error("Status is required to fetch daily speech list.");
    }

    return get(`/daily-speech/get_list/${stuId}/${status}`);
  },
};

export const ApiDailySpeechGetVoiceSample = {
  get: (contentId) => {
    if (!contentId) {
      throw new Error(
        "Daily speech content ID is required to fetch the voice sample."
      );
    }

    return fetchget2(`/daily-speech/speaking/sample/${contentId}`);
  },
};

export const ApiDailySpeechUploadVoice = {
  post: (contentId, formData) => {
    if (!contentId) {
      throw new Error(
        "Daily speech content ID is required when uploading a recording."
      );
    }

    if (!formData) {
      throw new Error(
        "Audio form data is required when uploading a recording."
      );
    }

    return post(`/daily-speech/upload/${contentId}`, formData);
  },
};

export const ApiDailySpeechGetAnalysis = {
  get: (contentId) => {
    if (!contentId) {
      throw new Error(
        "Daily speech content ID is required to fetch the analysis."
      );
    }

    return get(`/quiz/daily-speech/analysis/${contentId}`);
  },
};

export const ApiDailySpeechGetQuizAnalysis = {
  get: (quizId) => {
    if (!quizId) {
      throw new Error(
        "Daily speech quiz ID is required to fetch the quiz analysis."
      );
    }

    return get(`/daily-speech/quiz/${quizId}/analysis`);
  },
};

export const ApiDailySpeechGetUserRecord = {
  get: (contentId) => {
    if (!contentId) {
      throw new Error(
        "Daily speech content ID is required to fetch the user recording."
      );
    }

    return fetchget2(`/daily-speech/speaking/record/${contentId}`);
  },
};

export const ApiDailySpeechGetCompletedQuizzes = {
  get: (stuId, params = {}) => {
    if (!stuId) {
      throw new Error(
        "Student ID is required to fetch completed daily speech quizzes."
      );
    }

    const queryParams = new URLSearchParams();
    if (params.days) queryParams.append("days", params.days);
    if (params.limit) queryParams.append("limit", params.limit);

    const queryString = queryParams.toString();
    const url = `/daily-speech/get_completed_quizzes/${stuId}${
      queryString ? `?${queryString}` : ""
    }`;

    return get(url);
  },
};

export const ApiDailySpeechGetCompletedQuizDetail = {
  get: (dailySpeechId) => {
    if (!dailySpeechId) {
      throw new Error(
        "Daily speech quiz ID is required to fetch completed quiz detail."
      );
    }

    return get(`/daily-speech/get_completed_quiz_detail/${dailySpeechId}`);
  },
};
